function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("polygon", {
  fill: "#B4B4B4",
  points: "0,129.718 11.375,144.875 76.148,169.335 82.683,165.029 91.638,168.818 92.507,155.033  104.217,152.113 104.742,134.889 116.104,133.676 125.404,141.434 160.895,146.938 160.895,150.044 165.715,146.938 159.352,123  169.854,122.479 183.292,103.188 185.697,94.577 189.83,94.229 185.697,79.584 191.382,77.351 191.382,62.874 198.798,60.298  200,54.61 181.219,47.89 173.127,60.634 148.316,61.15 150.729,58.569 149.525,52.886 129.538,54.61 125.404,37.56 119.729,36.174  112.839,42.723 103.532,40.139 98.878,30.666 65.975,35.319 56.155,43.072 50.13,38.764 45.999,40.49 43.58,52.028 51.682,50.822  59.775,59.437 55.295,66.668 61.847,72.351 61.153,79.935 68.73,77.351 70.114,79.935 63.051,93.371 57.365,91.989 33.761,107.841  31.352,103.188 27.216,106.982 21.19,105.773 14.644,109.212 "
});

var Svg16 = function Svg16(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "MICH",
    x: "0px",
    y: "0px",
    width: "200px",
    height: "200px",
    viewBox: "0 0 200 200",
    enableBackground: "new 0 0 200 200",
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(Svg16, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/16.a4e0b270.svg";
export { ForwardRef as ReactComponent };